import { useEffect } from 'react';
import { useStoreActions, useStoreRehydrated } from '@discover-data/stores/restaurant/hooks';

const FEATURED_SORT_VARIANT = 'FEATURED_NEW_TOP_B';

export default function useSyncFeaturedSortVariant() {
  const setFeaturedSortVariant = useStoreActions((actions) => actions.setFeaturedSortVariant);
  const rehydrated = useStoreRehydrated();

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    // Rehydration replaces in-memory state with the model default.
    setFeaturedSortVariant(FEATURED_SORT_VARIANT);
  }, [rehydrated, setFeaturedSortVariant]);
}
